import React, { useState, useEffect } from "react";

export const Services = (props) => {
  const [currentIndexItems, setCurrentIndexItems] = useState(0);
  const [currentIndexItemsScreens, setCurrentIndexItemsScreens] = useState(0);

  // Datos del JSON para los dos carruseles
  const items = props.data?.items || [];
  const itemsScreens = props.data?.itemsScreens || [];

  // Obtener imágenes y textos para el primer carrusel
  const imagesItems = items.map((item) => item.images);
  const captionsItems = items.map((item) => item.text);

  // Obtener imágenes y textos para el segundo carrusel
  const imagesItemsScreens = itemsScreens.map((item) => item.images);
  const captionsItemsScreens = itemsScreens.map((item) => item.text);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexItems((prevIndex) => (prevIndex + 1) % imagesItems.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [imagesItems.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexItemsScreens(
        (prevIndex) => (prevIndex + 1) % imagesItemsScreens.length
      );
    }, 4500);
    return () => clearInterval(interval);
  }, [imagesItemsScreens.length]);

  const getStyle = (index, currentIndex, totalImages) => {
    const diff = (index - currentIndex + totalImages) % totalImages;

    if (diff === 0) {
      return { opacity: 1, transform: "translateX(0%) scale(1)", zIndex: 5 };
    } else if (diff === 1) {
      return {
        opacity: 0.8,
        transform: "translateX(50%) scale(0.9)",
        zIndex: 4,
      };
    } else if (diff === 2) {
      return {
        opacity: 0.8,
        transform: "translateX(100%) scale(0.8)",
        zIndex: 3,
      };
    } else if (diff === totalImages - 1) {
      return {
        opacity: 0.8,
        transform: "translateX(-50%) scale(0.9)",
        zIndex: 4,
      };
    } else if (diff === totalImages - 2) {
      return {
        opacity: 0.8,
        transform: "translateX(-100%) scale(0.8)",
        zIndex: 3,
      };
    } else {
      return { opacity: 0, transform: "translateX(0%) scale(0.7)", zIndex: 0 };
    }
  };

  return (
    <div id="services" style={styles.container}>
      <div style={styles.containerSlide}>
        <div style={styles.sectionTitle}>
          <h2>{props.data?.title || "Loading..."}</h2>
        </div>

        {/* Primer carrusel */}
        <div style={styles.carouselContainer}>
          <div style={styles.carousel}>
            {imagesItems.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Slide ${index}`}
                style={{
                  ...styles.carouselImage,
                  ...getStyle(index, currentIndexItems, imagesItems.length),
                }}
              />
            ))}
          </div>
          <div style={styles.caption}>
            <p style={styles.captionP}>{captionsItems[currentIndexItems]}</p>
          </div>
        </div>
      </div>

      
      <div style={styles.containerSlideB}>
      <div style={styles.sectionTitleB}>
        <h2>{props.data?.title2 || "Loading..."}</h2>
      </div>
      {/* Segundo carrusel */}
      <div style={styles.carouselContainer}>
        <div style={styles.carousel}>
          {imagesItemsScreens.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Slide ${index}`}
              style={{
                ...styles.carouselImage,
                ...getStyle(
                  index,
                  currentIndexItemsScreens,
                  imagesItemsScreens.length
                ),
              }}
            />
          ))}
        </div>
        <div style={styles.caption}>
          <p style={styles.captionP}>{captionsItemsScreens[currentIndexItemsScreens]}</p>
        </div>
      </div>
      </div>
      
    </div>
  );
};

const styles = {
  containerSlide: {
    background: "linear-gradient(to bottom, rgb(10, 58, 44) 0%, rgb(26, 151, 102) 100%)",
    height: "100vh",
    display: "flex", // Flexbox para centrar
    justifyContent: "center", // Centrado horizontal
    alignItems: "center", // Centrado vertical
    flexDirection: "column", // Asegura que el contenido esté en columna
    paddingTop: "50px",
    paddingBottom: "50px"
  },
  containerSlideB: {
    background: "linear-gradient(to top, rgb(10, 58, 44) 0%, rgb(26, 151, 102) 100%)",
    height: "100vh",
    display: "flex", // Flexbox para centrar
    justifyContent: "center", // Centrado horizontal
    alignItems: "center", // Centrado vertical
    flexDirection: "column", // Asegura que el contenido esté en columna
    paddingTop: "50px",
    paddingBottom: "50px"
  },
  container: {
    textAlign: "center",
    padding: "0px 0",
    width: "100%",
    backgroundColor: "#f9f9f9",
  },
  sectionTitle: {
    marginBottom: "40px",
    textAlign: "center",
    width: "80%", // Limita el ancho del título
    wordBreak: "break-word", // Permite la ruptura de palabras largas
    overflowWrap: "break-word", // Asegura que las palabras largas se ajusten
  },
  sectionTitleB: {
    marginBottom: "40px",
    textAlign: "center",
    width: "80%", 
    wordBreak: "break-word", 
    overflowWrap: "break-word",
  },
  carouselContainer: {
    position: "relative",
    width: "100%",
    margin: "0 auto 40px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  carousel: {
    display: "flex",
    position: "relative",
    width: "100%",
    height: "450px",
    justifyContent: "center",
    alignItems: "center",
  },
  carouselImage: {
    position: "absolute",
    width: "auto",
    height: "100%",
    maxHeight: "300px",
    objectFit: "contain",
    transition: "transform 0.5s ease, opacity 0.5s ease",
  },
  caption: {
    marginTop: "20px",
    fontWeight: "bold",
    color: "#FFF",
    textAlign: "center",
    width: "80%",
  },
  captionP: {
    fontSize: "25px",
    color: "#fff",
  },
};

